






import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { debounce } from 'lodash';
@Component({
	components: {},
})
export default class extends Vue {
	@Prop({ default: () => ({}) }) public item!: any;
	@Prop({ default: () => ({}) }) public form!: any;
	private text = '';
	private newChange = debounce(this.change, 300);
	private change() {
		this.form.filterValue = this.text;
		this.$emit('change');
	}
	get getType() {
		return (this.item && this.item.fieldType) || 'text';
	}
	@Watch('form.businessId')
	private onChildChanged() {
		this.text = '';
	}
	@Watch('$route.params.viewId')
	private ChildChanged() {
		this.text = '';
	}
}
